
import { QueryResult } from "./types";
import { contractStatsQueries } from "./user/contract-stats-queries";
import { distributionQueries } from "./user/distribution-queries";
import { timelineQueries } from "./user/timeline-queries";
import { expirationQueries } from "./user/expiration-queries";
import { recentContractsQueries } from "./user/recent-contracts-queries";
import { contractValueQueries } from "./user/contract-value-queries";
import { financialResultQueries } from "./user/financial-result-queries";

/**
 * User dashboard queries - refactored into logical groups imported from separate files
 */
export const userQueries = {
  // Contract statistics queries
  getUserContractStats: contractStatsQueries.getUserContractStats,
  
  // Distribution queries
  getContractsDistribution: distributionQueries.getContractsDistribution,
  getContractCostsByType: distributionQueries.getContractCostsByType,
  
  // Timeline queries
  getContractsTimeline: timelineQueries.getContractsTimeline,
  
  // Expiration queries
  getUpcomingExpirations: expirationQueries.getUpcomingExpirations,
  
  // Recent contracts queries
  getRecentContracts: recentContractsQueries.getRecentContracts,
  
  // Contract value queries
  getUserContractValue: contractValueQueries.getUserContractValue,
  
  // Financial result queries
  getUserFinancialResult: financialResultQueries.getUserFinancialResult
};
